import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LoaderComponent } from "./loader/loader.component";
import { AlertComponent } from "./alert/alert.component";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatIconModule } from "@angular/material/icon";
import { MatListModule } from "@angular/material/list";
import { MatToolbarModule } from "@angular/material/toolbar";
import { ToolbarComponent } from "./toolbar/toolbar.component";
import { SidenavComponent } from "./sidenav/sidenav.component";
import { EmployeePlacesComponent } from "./employee-places/employee-places.component";
import { ImgPipe } from "../pipes/img/img.pipe";
import { RouterModule } from "@angular/router";
import { AuthModule } from "../auth/auth.module";
import { MatBottomSheetModule } from "@angular/material/bottom-sheet";
import { ValidatePermissionDirective } from "../admin/directives/validate-permission.directive";
import { LoadingComponent } from "./loading/loading.component";
import { SnackbarComponent } from "./snackbar/snackbar.component";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { SwitchComponent } from "./switch/switch.component";
import { CurrencyInputComponent } from "./currency-input/currency-input.component";
import { MatFormFieldModule } from "@angular/material/form-field";
import { NgxCurrencyDirective } from "ngx-currency";
import { MatInputModule } from "@angular/material/input";
import { FormsModule } from "@angular/forms";
import { PermissionButtonsDirective } from "../admin/directives/permissionButtons.directive";
import { MatCardModule } from "@angular/material/card";

@NgModule({
  declarations: [
    LoaderComponent,
    AlertComponent,
    ToolbarComponent,
    LoadingComponent,
    SidenavComponent,
    EmployeePlacesComponent,
    ImgPipe,
    ValidatePermissionDirective,
    SnackbarComponent,
    SwitchComponent,
    CurrencyInputComponent,
    PermissionButtonsDirective,
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    RouterModule,
    MatListModule,
    MatToolbarModule,
    MatExpansionModule,
    MatDialogModule,
    AuthModule,
    MatBottomSheetModule,
    MatIconModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatFormFieldModule,
    NgxCurrencyDirective,
    MatInputModule,
    FormsModule,
    MatCardModule,
  ],
  exports: [
    LoaderComponent,
    AlertComponent,
    ToolbarComponent,
    SidenavComponent,
    LoadingComponent,
    MatDialogModule,
    ImgPipe,
    ValidatePermissionDirective,
    SnackbarComponent,
    SwitchComponent,
    CurrencyInputComponent,
    PermissionButtonsDirective,
    MatCardModule,
  ],
  providers: [ImgPipe],
})
export class BasicModule {}
